import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminPlanLogPage } from "@/features/admin/plan-log";

const search = z.object({
  orgId: z.string().uuid().optional().catch(undefined),
  planKey: z.enum(["trial", "free", "pro", "business"]).optional().catch(undefined),
});

export const Route = createFileRoute("/admin/plan-log")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Entitlement log · Admin · Malfak" }] }),
  component: PlanLogRoute,
});

function PlanLogRoute() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return <AdminPlanLogPage orgId={s.orgId} planKey={s.planKey} onFilter={(f) => void navigate({ search: f, replace: true })} />;
}
